import { ConfigProvider } from '@arco-design/web-react'
import zhCN from '@arco-design/web-react/es/locale/zh-CN'
import enUS from '@arco-design/web-react/es/locale/en-US'
import { ReactNode, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const arcoLocales = {
  'zh-CN': zhCN,
  en: enUS,
} as const

export function ArcoLocaleProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation()
  const locale = useMemo(() => {
    const lang = i18n.language.startsWith('zh') ? 'zh-CN' : 'en'
    return arcoLocales[lang]
  }, [i18n.language])

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>
}
